import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { TabularTypeDataset } from './tabular-type.dataset';

import { AzureSearchLinkedService } from 'app/model/linkedservice/azure-search.linkedservice';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.azureSearch.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.AzureSearch_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.AzureSearch_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: AzureSearchLinkedService.MODEL // Linked service redefined
        }
    }
})
export class AzureSearchDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
